import React, { useState, useMemo } from 'react'
import {
  Form,
  Button,
} from 'components/atoms'
import { Formik, Field } from 'formik';
import { FieldCustom } from 'components/molecules';
import PropTypes from 'prop-types'
import * as Yup from 'yup';
import styled from 'styled-components/macro';
import slugify from 'slugify'
import { slugRegex } from 'services/constants';
import { generateSubwebPath } from 'services/generators';

const PageSchema = Yup.object().shape({
  title: Yup.string()
    .min(2, 'Mínimo de 4 caracteres')
    .max(120, 'Máximo de 120 caracteres')
    .required('Campo obrigatório'),
  slug: Yup.string().matches(slugRegex, 'Apenas pode ter letras minúsculas, palavras separadas por -, e não pode conter a palavra noticias ou news').required('Campo obrigatório'),
});

const PageCreateForm = ({
  initialValues,
  subweb,
  lang,
  onChange,
  onSubmit,
  onDiscard,
  validate,
}) => {
  const [values, setValues] = useState(initialValues)
  const [disableSlug, setDisableSlugify] = useState(false)
  // when the values change Formik runs validate so we can values changing side effects here
  // update the page json by invoking onChange(newProps)
  const handleFormChange = (newValues) => {
    const slugFromTitle = slugify(newValues.title, {
      replacement: '-',
      remove: undefined,
      lower: true,
      strict: false,
    })

    setValues({
      ...newValues,
      slug: disableSlug ? newValues.slug : slugFromTitle
    })
    onChange(newValues)
    return validate(newValues)
  };

  const subwebUrl = useMemo(() => generateSubwebPath(
    { subweb, lang, withHost: true }
  ), [subweb, lang])

  return (
    <Formik
      initialValues={values}
      validationSchema={PageSchema}
      validate={handleFormChange}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values);
        setSubmitting(false);
      }}
      enableReinitialize
    >
      <Form>
        <Field
          title="Título"
          name="title"
          placeholder="Escreva aqui o título da página."
          component={FieldCustom}
          maxLetters={120}
        />
        <FieldWithAction>
          <Field
            title="Endereço amigável"
            name="slug"
            placeholder="titulo-da-pagina"
            component={FieldCustom}
            onBlur={() => setDisableSlugify(true)}
            modifiers={['stretch']}
            info={subwebUrl + values.slug}
          />
        </FieldWithAction>
        <Actions>
          <Button
            type="button"
            modifiers={['marginRight', 'capitalize']}
            onClick={onDiscard}
          >
              Cancelar
          </Button>
          <Button
            type="submit"
            modifiers={['dark', 'capitalize']}
          >
              Adicionar
          </Button>
        </Actions>
      </Form>
    </Formik>
  )
}

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${props => props.theme.spacing.l};
`;

const FieldWithAction = styled.div`
  display: inline-flex;
`

FieldWithAction.Action = styled.div`
  margin-top: 2rem;
  padding-left: ${props => props.theme.spacing.xs};
`

PageCreateForm.defaultProps = {
  initialValues: {
    title: '',
    slug: ''
  },
  onSubmit: () => {},
  onDiscard: () => {},
  onChange: () => { },
  validate: () => ({}),
}

PageCreateForm.propTypes = {
  initialValues: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string,
  }),
  subweb: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onDiscard: PropTypes.func,
  onSubmit: PropTypes.func,
  validate: PropTypes.func,
}

export default PageCreateForm
